<template>
  <div class="card-container">
    <Row>
      <Col span="24" class="box-header">
        <h2>Оплаты</h2>
      </Col>
      <Col span="24" class="box-header-filter">
        <Menu
          mode="horizontal"
          :active-name="defaultFilter"
          @on-select="selectFilter"
        >
          <MenuItem name="year" class="menu-item">
            Год
          </MenuItem>
          <MenuItem name="month" class="menu-item">
            Месяц
          </MenuItem>
          <MenuItem name="week" class="menu-item">
            Неделя
          </MenuItem>
          <MenuItem name="day" class="menu-item">
            День
          </MenuItem>
        </Menu>
      </Col>
    </Row>

    <div v-if="displayChart">
      <paymentType :labels="labels" :data="data" style="margin-top: 20px" :height="330" :width="330"></paymentType>
      <Row style="margin-top: 20px">
        <Col span="12">
          <div
            class="box-count-label"
            v-for="(label, index) in labels"
            :key="label"
          >
            <div
              class="box-count-circle"
              :style="{
                background: backgroundColor[index]
              }"
            ></div>
            {{ label }}
          </div>
        </Col>
        <Col span="12">
          <div
            class="box-count-value"
            v-for="(val, index) in data"
            :key="val"
          >{{ formatNumber(val) }} {{ $store.state.currency }}
          </div>
        </Col>
      </Row>
    </div>
    <div v-else class="box-no-data">
      Нет данных для отображения
    </div>

    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>
<script>
    import paymentType from "./paymentType";
    import { base_url } from "../../http";
    import { formatNumber } from "../../base/base_func.js";
    export default {
        name: "paymentType2",
        components: {
            paymentType
        },
        data() {
            return {
                loading: true,
                defaultFilter: "month",
                labels: [],
                data: [],
                backgroundColor: [
                    "#FFDA83",
                    '#FF8373',
                    '#55D8FE'
                ],
            };
        },
        computed: {
            displayChart(){
                return this.data.reduce((a, b) => a + b, 0) !== 0;
            }
        },
        methods: {
            selectFilter: function(period) {
                this.fetchPayments(period);
            },
            fetchPayments: function(period) {
                this.loading = true;
                let url = `${base_url}/charts/payment_type/`;
                this.$http
                    .get(url, {
                        params: { period: period }
                    })
                    .then(result => {
                        this.labels = [];
                        this.data = [];
                        result.data.forEach(product => {
                            if (product.type == 'Payment type cash') {
                              this.labels.push("Наличные");
                            } else if (product.type == 'Payment type card') {
                              this.labels.push("Карта");
                            } else if (product.type == 'Payment type mobile') {
                              this.labels.push("Мобильные");
                            } else {
                              this.labels.push(product.type);
                            }
                            
                            this.data.push(product.sum);
                        });
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            formatNumber(val) {
                return formatNumber(val);
            }
        },
        mounted: function() {
            this.fetchPayments(this.defaultFilter);
        }
    };
</script>

<style scoped>
  .card-container {
    padding: 20px 30px;
    position: relative;
    height: 100%;
  }
  .box-header {
    text-align: left;
    padding-bottom: 10px;
  }
  .ivu-menu-horizontal {
    height: auto;
    line-height: 1.2;
    margin-bottom: 20px;
  }
  .box-count-label {
    text-align: left;
    font-weight: bold;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-bottom: 3px;
  }
  .box-count-value {
    text-align: right;
    /*font-weight: bold;*/
    font-size: 14px;
    margin-bottom: 3px;
  }
  .box-header-filter {
    text-align: right;
    /*font-weight: bold;*/
    /*font-size: 10px !important;*/
    /*color: rgb(141, 141, 141) !important;*/
  }
  .box-count-circle {
    display: inline-block;
    width: 16px;
    height: 16px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    border-radius: 25px;
    margin-right: 10px;

    /*background: red;*/
  }
  .box-no-data {
    font-size: 20px;
    color: #80808094;
    margin: 80px 0;
  }
  .ivu-menu {
    z-index: 1;
  }
  .menu-item {
    font-size: 16px;
    line-height: 30px !important;
    padding: 0 5px !important;
    float: right;
  }
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
    /*color: #2d8cf0;*/
    /*border-bottom: None;*/
    /*font-weight: bold;*/
    color: rgba(37, 215, 126, 1);
    border-bottom: unset;
  }
  .ivu-menu-horizontal.ivu-menu-light::after {
    background: white;
  }
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
    border-bottom: unset;
    /*color: #515a6e;*/
  }
  .ivu-menu-horizontal .ivu-menu-item,
  .ivu-menu-horizontal .ivu-menu-submenu {
    color: #8080809e;
    /*float: left;*/
    /*padding: 0 10px;*/
    /*position: relative;*/
    /*cursor: pointer;*/
    /*z-index: 3;*/
    /*transition: all 0.2s ease-in-out;*/
  }


  @media screen and (max-width: 1900px) {
    .menu-item {
      font-size: 15px;
    }
  }
  @media screen and (max-width: 1500px) {
    .menu-item {
      font-size: 14px;
    }
  }


  @media screen and (max-width: 991px) {
    h2 {
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/home/paymentType2.vue